import '__common/pixiCanvasFallback';
import { autoDetectRenderer, IRenderer } from 'pixi.js';
import { state } from '__common/store';
import { setupRendererLite } from './rendererLite';

let renderer: IRenderer;

export function setupRenderer(width: number, height: number) {
  if (state().app && state().app.isUbuilderLite) {
    renderer = setupRendererLite(width, height) as any;
    return renderer;
  }

  try {
    renderer = autoDetectRenderer({
      width,
      height,
      antialias: true,
    });
  } catch (_) {
    renderer = autoDetectRenderer({
      width,
      height,
      antialias: true,
      forceCanvas: true,
    });
  }

  return renderer;
}

export function getRenderer() {
  return renderer;
}

export function destroyRenderer() {
  if (renderer) {
    try {
      renderer.destroy();
    } catch (_) { /* already destroyed (e.g., HMR replayed unmount) */ }
    renderer = null;
  }
}
